import React, { useEffect, useMemo } from "react";
import { useNodesState, useReactFlow } from "reactflow";
import "../../components/Loader/Loader.scss";
import { useQueryGeneratorContext } from "../../context/QueryBuilder/QueryGeneratorContext";
import SemanticTopBar from "../../components/SemanticModel/SemanticTopBar";
import QueryPreviewBar from "../../components/Querbuilder/QueryPreviewBar";
import { useQueryTablesDataContext } from "../../context/QueryBuilder/QueryTablesDataContext";
import SemanticTableNode from "./SemanticTableNode";
import CustomReactFlow from "../../components/FlowBoard/CustomReactflow";
import { createGridLayout, getResponsiveGridLayout, useContainerWidth } from "../../utilities/Constants/CustomNodes";

const nodeTypes = { customNode: SemanticTableNode };

const SemanticFlowWrapper = () => {
  const { setSelectedTableNames, setCheckedColumns, selectedTableNames, tableQueryDataMap } = useQueryGeneratorContext();
  const { tableList } = useQueryTablesDataContext();

  const { setViewport } = useReactFlow();
  const [nodes, setNodes, onNodesChange] = useNodesState([])
  const { containerRef, containerWidth } = useContainerWidth();

  useEffect(() => {
    if (!containerWidth) return;
    if (!tableList?.length) return setNodes([]);
    const initialNodesFromData = createGridLayout(tableList, containerWidth);
    const responsiveNodes = getResponsiveGridLayout(initialNodesFromData, containerWidth);
    setNodes(responsiveNodes);

  }, [containerWidth, tableList]);


  useEffect(() => {
    setViewport({ x: 0, y: 0, zoom: 1 });
  }, []);

  const updatedNodes = useMemo(
    () =>
      nodes.map((node: any) => ({
        ...node,
        data: {
          ...node.data,
          setCheckedColumns,
          setSelectedTableNames,
          tableItem: tableQueryDataMap?.[node.data.header] || {},
        },
      })),
    [tableQueryDataMap, nodes, setCheckedColumns, setSelectedTableNames]
  );

  return (
    <CustomReactFlow
      containerRef={containerRef}
      nodes={updatedNodes}
      edges={[]}
      onNodesChange={onNodesChange}
      nodeTypes={nodeTypes}
      defaultViewport={{ x: 0, y: 0, zoom: 1 }}
      minZoom={0.5}
      maxZoom={2}
      panOnScroll
      selectionOnDrag
      nodesDraggable={false}
    >
      <div style={{ padding: "16px" }}>
        <SemanticTopBar />
        {selectedTableNames.length > 0 &&
          selectedTableNames.map((tableName: any, index: number) => (
            <QueryPreviewBar
              key={tableName}
              index={index}
              table={tableName}
              tableQueryDataMap={tableQueryDataMap}
            />
          ))}
      </div>
    </CustomReactFlow>
  );
};

export default SemanticFlowWrapper;
